// 自定义上报类
class ItraceReport {
  /**
   * 上报数据
   * @param params - 包含配置信息和其他参数的对象
   */
  report(params: { config: any; data: any; request: any }) {
    try {
      // 检查 window.wpk 是否存在
      if (!this.isWPKAvailable()) {
        return; // 如果不存在，则直接返回
      }

      const { config, data, request } = params;
      const { result } = data;

      // 处理 bizValue 和 params 字段
      let bizValue = this.stringifyIfObject(result?.bizValue); // 将 bizValue 转换为字符串
      let paramsStr = this.stringifyIfObject(params); // 将 params 转换为字符串

      // 构造上报日志对象
      const log = {
        category: 100,
        msg: config?.baseURL || '', // 使用基础 URL 或者默认为空字符串
        c1: result?.traceId, // 追踪 ID
        c2: request?.status, // 请求状态
        c3: config?.data || '', // 配置中的数据字段或默认为空字符串
        c4: bizValue || '', // bizValue 字段或默认为空字符串
        c5: request?.responseURL || '', // 响应 URL 或默认为空字符串
        c6: result?.bizCode, // 商业代码
        c7: paramsStr || '', // 参数字符串或默认为空字符串
      };

      console.log(log, '打印构造的日志对象 log'); // 打印构造的日志对象
      (window as any).wpk.report(log); // 发送日志到 wpk 报告系统
    } catch (error) {
      console.error('Error reporting to WPK:', error);
    }
  }

  /**
   * 判断是否可以访问 WPK
   * @returns boolean - 返回是否可以访问 WPK 的布尔值
   */
  private isWPKAvailable(): boolean {
    return Boolean((window as any).wpk);
  }

  /**
   * 如果输入是一个对象，则将其转换成 JSON 字符串；否则直接返回该值
   * @param value - 输入的值
   * @returns string | undefined - 返回转换后的字符串或原值
   */
  private stringifyIfObject(value: any): string | undefined {
    if (typeof value === 'object') {
      try {
        return JSON.stringify(value);
      } catch (error) {
        console.error('Error stringifying object:', error);
        return undefined;
      }
    }
    return value;
  }
}

// 创建实例并导出
export const apiItraceTracker = new ItraceReport();
